import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./7th.css";

import { FaBook, FaGlobeAsia, FaBookOpen } from "react-icons/fa";
import { GiBookshelf } from "react-icons/gi";
import { MdScience } from "react-icons/md";
import { BiMath } from "react-icons/bi";
import { BsTranslate } from "react-icons/bs";

const content = {
  en: {
    heading: "📘 7th Standard Subjects",
    subjects: [
      {
        name: "Marathi",
        icon: <GiBookshelf />,
        className: "marathi",
        backendSubject: "Marathi",
      },
      {
        name: "English",
        icon: <BsTranslate />,
        className: "english",
        backendSubject: "English",
      },
      {
        name: "Hindi",
        icon: <FaBookOpen />,
        className: "hindi",
        backendSubject: "Hindi",
      },
      {
        name: "Mathematics",
        icon: <BiMath />,
        className: "maths",
        backendSubject: "Maths",
      },
      {
        name: "Science",
        icon: <MdScience />,
        className: "science",
        backendSubject: "Science",
      },
      {
        name: "History",
        icon: <FaBook />,
        className: "history",
        backendSubject: "History",
      },
      {
        name: "Geography",
        icon: <FaGlobeAsia />,
        className: "geography",
        backendSubject: "Geography",
      },
    ],
  },

  mr: {
    heading: "📘 इयत्ता ७ वी विषय",
    subjects: [
      {
        name: "मराठी",
        icon: <GiBookshelf />,
        className: "marathi",
        backendSubject: "Marathi",
      },
      {
        name: "इंग्रजी",
        icon: <BsTranslate />,
        className: "english",
        backendSubject: "English",
      },
      {
        name: "हिंदी",
        icon: <FaBookOpen />,
        className: "hindi",
        backendSubject: "Hindi",
      },
      {
        name: "गणित",
        icon: <BiMath />,
        className: "maths",
        backendSubject: "Maths",
      },
      {
        name: "सामान्य विज्ञान",
        icon: <MdScience />,
        className: "science",
        backendSubject: "Science",
      },
      {
        name: "इतिहास",
        icon: <FaBook />,
        className: "history",
        backendSubject: "History",
      },
      {
        name: "भूगोल",
        icon: <FaGlobeAsia />,
        className: "geography",
        backendSubject: "Geography",
      },
    ],
  },
};

const Seventh = ({ language = "mr" }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const data = content[language];
  const navigate = useNavigate();

  const handleClick = (backendSubject) => {
    navigate("/quiz-details", {
      state: {
        standard: 7,
        subject: backendSubject,
      },
    });
  };

  return (
    <section className="seventh-section">
      <h2 className="seventh-title">{data.heading}</h2>

      <div className="subjects-board">
        <div className="subjects-grid">
          {data.subjects.map((sub, index) => (
            <div
              key={index}
              className={`subject-card ${sub.className}`}
              onClick={() => handleClick(sub.backendSubject)}
            >
              <div className="icon">{sub.icon}</div>
              <h3>{sub.name}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Seventh;